<p-fieldset>
  <p-header class="article-title">
    <span class="article-title">Log de Alterações - Configuração de Sling</span>
    <button class="fab-button primary" appFiltersButton pTooltip="Exibir/Ocultar Filtros" tooltipPosition="left">
      <i class="pi pi-filter"></i>
    </button>
  </p-header>

  <form class="filters" (submit)="find()" appFilters>
    <div class="filter-row">
      <div class="form-control">
        <label>Período</label>
        <p-calendar
          dateFormat="dd/mm/yy"
          name="dateRange"
          [monthNavigator]="true"
          [yearNavigator]="true"
          [yearRange]="'2000:2055'"
          rPCalendarMask
          appendTo="body"
          selectionMode="range"
          [(ngModel)]="rangeLogDate"
          [showIcon]="true"
          i18n>
        </p-calendar>
      </div>

      <div class="buttons">
        <div class="form-button">
          <button type="submit" class="primary easymarine" [disabled]="loading">
            <i class="pi pi-search"></i> Buscar
          </button>
        </div>
      </div>
    </div>
  </form>

  <div class="logs-container" *ngIf="!loading && logs.length > 0">
    <app-sling-config-change-log-table [logs]="logs"></app-sling-config-change-log-table>
  </div>

  <div class="empty-state" *ngIf="!loading && logs.length === 0">
    <i class="pi pi-info-circle"></i>
    <p>Nenhum log encontrado para o período selecionado.</p>
  </div>

  <div class="loading-state" *ngIf="loading">
    <i class="pi pi-spin pi-spinner"></i>
    <p>Carregando logs...</p>
  </div>
</p-fieldset>
